export const fileOpen = async (options: { description: string; extensions: string[] }) => {
  // 简化实现，实际项目中需要使用文件选择器
  return new Promise<File>((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = options.extensions.map(ext => `.${ext}`).join(',');
    
    input.onchange = (e) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files[0]) {
        resolve(target.files[0]);
      } else {
        reject(new Error('No file selected'));
      }
    };
    
    input.click();
  });
};